import React from 'react';
import Profile from '../profile/profile';
import {ReactComponent as Logo} from "./theme/svg/WE-logo.svg";
import {Box, Button, Container} from "@material-ui/core";
import {FormattedMessage, useIntl} from "react-intl";
import { Locale } from './api/model';

interface Props {
  locale: Locale,
  showErrorModal: (title: string, description: string, raw?: any) => void;
}

const Header: React.FunctionComponent<Props> = (props) => {
    const intl = useIntl();
    return (
        <Box component='header' bgcolor='common.white'>
            <Container maxWidth='lg'>
                <Box display='flex'
                     flexDirection={{xs: 'column', md: 'row'}}
                     alignItems='center'
                     justifyContent={{xs: 'center', md:'space-between'}}
                     pt={{xs: 4 ,md: 5}}
                     pb={{xs: 2, md: 5}}
                >
                    <Box display='inline-flex' mb={{xs: 3.5, md: 0}}>
                        <Logo width='192px' height='46px' />
                    </Box>
                    <Button target='_blank'
                            component='a'
                            variant='text'
                            href={intl.formatMessage({id: 'LinkHMC'})}
                    >
                        <FormattedMessage
                            id='HMC'
                        />
                    </Button>
                </Box>
            </Container>

            <Profile locale={props.locale} showErrorModal={props.showErrorModal}/>
        </Box>
    )
}

export default Header;
